import styled from 'styled-components';

export const Fotter = styled.div`
  display: flex;
`;

export const Box = styled.div`
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 30px;
  padding-bottom: 30px;
`;

export const InputWrapper = styled.div<{ isHalf?: boolean }>`
  padding: 0 15px;
  width: 100%;
  &:not(&:last-of-type) {
    margin-bottom: 16px;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: ${(props) => (props.isHalf ? '50%' : '100%')};
  }
`;

export const Fieldset = styled.fieldset`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
`;

export const Footer = styled.div`
  display: flex;
  padding: 0 15px;
  gap: 16px;
`;

export const TextAreaLabel = styled.p`
  margin-right: 12px;
  font-size: 14px;
  color: rgb(150, 151, 155);
`;
